import React from "react";
import { useNavigate } from "react-router-dom";
import { CheckCircle } from "lucide-react";

export default function OrderSuccess() {
  const navigate = useNavigate();

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "2rem",
        background: "#f9fafb",
      }}
    >
      <div
        style={{
          maxWidth: "480px",
          width: "100%",
          background: "white",
          borderRadius: "16px",
          padding: "2.5rem 2rem",
          boxShadow: "0 10px 25px rgba(0,0,0,0.08)",
          textAlign: "center",
        }}
      >
        <div
          style={{
            width: "64px",
            height: "64px",
            borderRadius: "999px",
            background: "#dcfce7",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            margin: "0 auto 1.5rem",
          }}
        >
          <CheckCircle size={36} color="#16a34a" />
        </div>
        <h1
          style={{
            fontSize: "1.8rem",
            marginBottom: "0.5rem",
            color: "#111827",
          }}
        >
          Order Successful
        </h1>
        <p
          style={{
            fontSize: "0.95rem",
            color: "#6b7280",
            marginBottom: "2rem",
          }}
        >
          Thank you for your purchase! Your order has been placed successfully.
          You can view the details of your order in your retailer dashboard.
        </p>
        <button
          onClick={() => navigate("/retailer-dashboard/orders")}
          style={{
            width: "100%",
            padding: "0.85rem 1.25rem",
            background: "#0e4410",
            color: "white",
            border: "none",
            borderRadius: "999px",
            fontSize: "0.95rem",
            fontWeight: 600,
            cursor: "pointer",
            marginBottom: "0.75rem",
          }}
        >
          View My Orders
        </button>
        <button
          onClick={() => navigate("/marketplace")}
          style={{
            width: "100%",
            padding: "0.85rem 1.25rem",
            background: "white",
            color: "#0e4410",
            border: "1px solid #0e4410",
            borderRadius: "999px",
            fontSize: "0.95rem",
            fontWeight: 500,
            cursor: "pointer",
          }}
        >
          Continue Shopping
        </button>
      </div>
    </div>
  );
}